import { render, staticRenderFns } from "./uploadSwiper.vue?vue&type=template&id=6f5823bb&scoped=true"
import script from "./uploadSwiper.vue?vue&type=script&lang=js"
export * from "./uploadSwiper.vue?vue&type=script&lang=js"
import style0 from "./uploadSwiper.vue?vue&type=style&index=0&id=6f5823bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5823bb",
  null
  
)

export default component.exports